// extracted by mini-css-extract-plugin
module.exports = {"root":"WizardNavigation_root__3jLR8","centerContent":"WizardNavigation_centerContent__3UPo9","buttonGroup":"WizardNavigation_buttonGroup__1vYCy"};